
import $ from 'jquery';
import VideoPlayer from './shared/videoPlayer';

$(function () {
    if ($('#all-testimonials').length) {
        new VideoPlayer();
        vt = (function () {
            var default_take = 15;
            var video_take = 8;
            var start = 0;
            var startv = 0;
            var take = default_take;
            var takev = video_take;
            var type = "All";

            vt = this;
            $(document).ready(function () {
                getTestimonials(start, take, type);
                getVideoTestimonials(startv, takev);
            });

            function showLoading() {
                $("#wait").show();
                $("#seemore").hide();
            }

            function hideLoading() {
                $("#wait").hide();
            }


            function seeMore() {
                start += default_take;
                getTestimonials(start, take, type);
            }

            function seeMoreVideos() {
                startv += video_take;
                getVideoTestimonials(startv, takev);
            }

            function removeAllActive() {
                $("#label-all").addClass("badge-allInactive");
                $("#label-all").removeClass("badge-allActive");

                $("#label-testimonial").addClass("badge-TTInactive");
                $("#label-testimonial").removeClass("badge-TTActive");

                $("#label-zillow").addClass("badge-zillowInactive");
                $("#label-zillow").removeClass("badge-zillowActive");

                $("#label-facebook").addClass("badge-facebookInactive");
                $("#label-facebook").removeClass("badge-facebookActive");

                $("#label-google").addClass("badge-googleInactive");
                $("#label-google").removeClass("badge-googleActive");

                $("#label-yelp").addClass("badge-yelpInactive");
                $("#label-yelp").removeClass("badge-yelpActive");

                $("#label-trustpilot").addClass("badge-trustpilotInactive");
                $("#label-trustpilot").removeClass("badge-trustpilotActive");


            }

            function filterTestimonials(theType) {
                removeAllActive()
                if (theType == "All") {
                    $("#label-all").removeClass("badge-allInactive");
                    $("#label-all").addClass("badge-all");
                }
                if (theType == "TT") {
                    $("#label-testimonial").removeClass("badge-TTInactive");
                    $("#label-testimonial").addClass("badge-TTActive");
                }
                if (theType == "ZW") {
                    $("#label-zillow").removeClass("badge-zillowInactive");
                    $("#label-zillow").addClass("badge-zillowActive");
                }
                if (theType == "UF") {
                    $("#label-facebook").removeClass("badge-facebookInactive");
                    $("#label-facebook").addClass("badge-facebookActive");
                }
                if (theType == "YL") {
                    $("#label-yelp").removeClass("badge-yelpInactive");
                    $("#label-yelp").addClass("badge-yelpActive");
                }
                if (theType == "UG") {
                    $("#label-google").removeClass("badge-googleInactive");
                    $("#label-google").addClass("badge-googleActive");
                }
                if (theType == "TP") {
                    $("#label-trustpilot").removeClass("badge-trustpilotInactive");
                    $("#label-trustpilot").addClass("badge-trustpilotActive");
                }
                start = 0;
                take = default_take;
                type = theType;


                $("#testimonials-list").html("");
                getTestimonials(0, 10, type);
            }

            function getTestimonials(from, count, type) {
                showLoading();
                var memberId = $("#member").val();

                $.ajax({
                    url: "/Testimonials/GetTestimonials",
                    async: true,
                    type: "GET",
                    contentType: 'application/json; charset=utf-8',
                    data: { start: from, take: count, memberId: memberId, provider: type },
                    success: function (ret) {

                        var pre = $(".testimonial-item").length;

                        if (from == 0) {
                            $("#testimonials-list").html(ret);

                        } else {
                            $("#testimonials-list").append(ret);
                        }

                        setTimeout(function () {

                            var total = $(".testimonial-item").length;
                            $("#totals").html("(" + total + ")");

                            if (total - pre < count) {
                                $("#seemore").hide();
                            } else {
                                $("#seemore").show();
                            }

                            timeago.render(document.querySelectorAll('.timeago'));

                            hideLoading();
                        }, 100);


                    },
                    error: function (request, status, error) {
                        hideLoading();
                        alert(error);
                    }
                });
            }

            function share(id) {

                $("#share-" + id).hide();
                $("#shared-" + id).show();
            }

            function copy(value, id) {

                var t = document.getElementById('t');

                t.innerHTML = value;
                t.select();
                try {
                    document.execCommand('copy');
                    $("#copy-" + id).hide();
                    $("#copied-" + id).show();
                } catch (err) {
                    console.log('Unable to copy text');
                }
                t.innerHTML = '';
            }

            function getVideoTestimonials(from, count, type) {
                $("#waitVideos").show();
                $("#seemoreVideos").hide();
                var memberId = $("#member").val();
                $.ajax({
                    url: window.location.pathname + "/GetVideoTestimonials",
                    async: true,
                    type: "GET",
                    contentType: 'application/json; charset=utf-8',
                    data: { start: from, take: count, memberId: memberId, provider: type },
                    success: function (ret) {

                        var pre = $(".video-item").length;

                        $("#videos-list").html(ret);
                        $("#waitVideos").hide();



                    },
                    error: function (request, status, error) {
                        $("#waitVideos").hide();
                        alert(error);
                    }
                });
            }

            return {
                seeMore: seeMore,
                copy: copy,
                share: share,
                seeMoreVideos: seeMoreVideos,
                filterTestimonials: filterTestimonials
            };

        }());
    }
});
$(function () {
    if ($('#testimonial_video_upload').length) {

        vt = (function () {
            var save_uploaded_video_url = "/Testimonials/SaveUploadedVideo";
            var validate_url = "/Testimonials/ValidateUpload";
            var status_url = "/Testimonials/Status/?token=";
            var timer;

            var timerInterval = max_duration;
            var typeVideo = 'video/webm;';
            let camera_button = document.querySelector("#start-camera");
            let video = document.querySelector("#video");
            let start_button = document.querySelector("#start-record");
            let stop_button = document.querySelector("#stop-record");
            let retry_button = document.querySelector("#retry-record");
            let camera = false;
            let camera_stream = null;
            let media_recorder = null;
            let blobs_recorded = [];

            $(document).ready(function () {
                setupPage();

                //$("#videoInfoForm").submit(function (e) {
                //    debugger;
                //    e.preventDefault();
                //    var isIncentive = $("#isIncentive").val();
                //    if (isIncentive == 'True') {
                //        var namev = $("#name-voucher").val();
                //        var emailv = $("#email-voucher").val();

                //        $("#authorEmail").val(emailv);
                //        $("#authorName").val(namev);
                //    }
                //    else {

                //        var firstName = $("#firstName").val();
                //        var lastName = $("#lastName").val();
                //        $("#authorName").val(firstName + ' ' + lastName);
                //        $("#authorNameSpan").text($("#authorName").val());
                //        $("authorNameA").attr("href", encodeURI("/testimonials/disclaimer?name=" + $("#authorName").val()));
                //    }

                //    $("#testimonial_video_info").hide();
                //    $("#testimonial_disclaimer").show();
                //});
            });


            camera_button.addEventListener('click', async function () {
                camera_stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
                video.srcObject = camera_stream;
                video.muted = true;

                $("#start-camera").hide();
                $("#start-record").show();
            });

            retry_button.addEventListener('click', async function () {
                $("#video-available").hide();
                $("#video-recording").show();
                camera_button.click();
            });

            start_button.addEventListener('click', function () {

                // set MIME type of recording as video/webm
                $("#video-available").hide();
                $("#stop-record").show();
                $("#start-record").hide();
                $("#timeClock").show();
                $("#button-continue").addClass("button-disabled");







                var types = getSupportedMimeTypes();
                typeVideo = types[0];


                media_recorder = new MediaRecorder(camera_stream, { mimeType: typeVideo });
                media_recorder.start();

                var counter = 0;
                clearTheInterval(timer);
                timer = setInterval(function () {
                    ++counter;
                    if (counter >= timerInterval) {

                        clearTheInterval(timer);
                        media_recorder.stop();
                        alert("Max length reached!");
                    }

                    $("#timeClock").html(new Date(counter * 1000).toISOString().substr(14, 5));

                }, 1000);


            });

            stop_button.addEventListener('click', function () {
                $("#stop-record").hide();
                $("#start-record").show();
                $("#timeClock").hide();
                $("#button-continue").removeClass("button-disabled");
                clearTheInterval(timer);

                media_recorder.ondataavailable = e => {
                    blobs_recorded = [];
                    blobs_recorded.push(e.data);

                    var new_blob = URL.createObjectURL(new Blob(blobs_recorded, { type: typeVideo }));
                    var videoElement = document.getElementById("video-pre");
                    videoElement.controls = true;
                    videoElement.src = new_blob;



                    $("#video-recording").hide();

                    $("#video-available").show();
                    $("#retry-record").show();
                };
                media_recorder.stop();



            });

            function getSupportedMimeTypes() {
                const VIDEO_TYPES = [
                    "webm",
                    "ogg",
                    "mp4",
                    "x-matroska"
                ];
                const VIDEO_CODECS = [
                    "vp9",
                    "vp9.0",
                    "vp8",
                    "vp8.0",
                    "avc1",
                    "av1",
                    "h265",
                    "h.265",
                    "h264",
                    "h.264",
                    "opus",
                ];

                const supportedTypes = [];
                VIDEO_TYPES.forEach((videoType) => {
                    const type = `video/${videoType}`;
                    VIDEO_CODECS.forEach((codec) => {
                        const variations = [
                            `${type};codecs=${codec}`,
                            `${type};codecs:${codec}`,
                            `${type};codecs=${codec.toUpperCase()}`,
                            `${type};codecs:${codec.toUpperCase()}`,
                            `${type}`
                        ]
                        variations.forEach(variation => {
                            if (MediaRecorder.isTypeSupported(variation))
                                supportedTypes.push(variation);
                        })
                    });
                });
                return supportedTypes;
            }

            function clearTheInterval(i) {
                clearInterval(timer);
            }

            function setupPage() {

                //$("#upload_link").on('click', function (e) {
                //	e.preventDefault();
                //	$("#inputImage:hidden").trigger('click');
                //});

                var dropZone = document.getElementById('dropContainer');
                dropZone.addEventListener('dragover', handleDragOver, false);
                dropZone.addEventListener('drop', handleFileSelect, false);


            }

            function handleFileSelect(evt) {
                evt.stopPropagation();
                evt.preventDefault();

                var files = evt.dataTransfer.files; // FileList object.

                if (files.length == 1) {
                    var file = files[0];
                    if (file.type.match(/video.*/)) {
                        saveFile(evt.dataTransfer);
                    } else {
                        alert("Upload a video file.");
                    }
                } else {
                    alert("Only one file upload allowed.");
                }

            }

            function handleDragOver(evt) {
                evt.stopPropagation();
                evt.preventDefault();
                evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
            }

            function hideLoading() {
                $("#loader").removeClass("is-active");
            }

            function showLoading(message) {


                $("#loader").addClass("is-active");
                $("#loader").attr("data-text", (message == undefined || message == null) ? "Loading, please wait .." : message);

            }


            function uploadVideo() {
                if (!$("#button-continue").hasClass("button-disabled")) {

                    var blob = new Blob(blobs_recorded, { type: typeVideo });


                    upload(null, blob, true);
                }

                camera_stream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }

            function uploadNext() {

                $("#upload-preview").hide();
                showInformation();
                goUp();
            }
            function goBackUpload() {
                $("#upload-preview").hide();
                $("#testimonial_video").show();
                $("#testimonial_video_upload").show();
                $("#video-url").val("");
                goUp();
            }

            function goBackDisclaimer() {
                $("#testimonial_disclaimer").hide();
                $("#testimonial_video_info").show();
                goUp();
            }

            function goBack() {
                $("#stop-record").click();
                $("#record-video").hide();
                $("#video-available").hide();
                $("#testimonial_video").show();
                goUp();
            }

            function recordVideo() {
                hideErrorBanner()
                camera = true;
                $("#start-record").show();
                $("#video-available").hide();
                $("#stop-record").hide();
                $("#retry-record").hide();
                $("#testimonial_video").hide();
                $("#record-video").show();
                $("#video-recording").show();

                camera_button.click();
            }

            function goUp() {
                setTimeout(function () {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 200);


            }
            function upload(file, info, camera) {
                debugger;
                var formData = new FormData();
                if (file != null) {
                    formData.append("videoUrl", file);
                } else {
                    if (info != null) {
                        formData.append("videoData", info);
                    } else {
                        alert("Error: File not found!");
                        return;
                    }
                }

                var isIncentive = $("#isIncentive").val();

                debugger;
                if ((token != "" && email != "") || isIncentive == 'True') {
                    if (isIncentive == 'True') {
                        var token = $("#token").val();
                        var email = $("#email").val();
                        formData.append("token", token);
                        formData.append("email", email);
                    }
                    else {
                        var mySite = $("#mySite").val();
                        formData.append("mySite", mySite);
                    }
                    formData.append("camera", camera);
                    showLoading("Uploading , please wait..");
                    $.ajax({
                        url: save_uploaded_video_url,
                        type: 'POST',
                        processData: false,
                        data: formData,
                        contentType: false,
                        success: function (response) {
                            hideLoading();
                            debugger;
                            if (response.success) {
                                hideErrorBanner();
                                $("#video-url").val(response.data.url);
                                $("#video-upload-pre").attr("src", response.data.url);
                                $("#publicId").val(response.data.publicId);

                                $("#testimonial_video_upload").hide();
                                $("#record-video").hide();
                                $("#testimonial_video").hide();
                                if (camera) {


                                    showInformation();
                                } else {
                                    $("#upload-preview").show();
                                }

                                goUp();
                            } else {

                                showErrorBanner(response.message);
                            }
                        },
                        error: function (request, status, error) {
                            hideLoading();
                            alert(request.error);
                        }
                    });
                } else {
                    alert("Error: Invalid parameter");
                }


            }


            function validateFile(f, cb) {
                debugger;

                showLoading("Validating file, please wait..");

                var duration = 0;
                var i = 0;
                var videoElement = document.createElement('video');
                videoElement.src = URL.createObjectURL(f);;
                if (f.size > max_size) {
                    hideLoading();
                    //alert("Max file size exceeded ( " + (max_size / 1000000) + " MB)");
                    showErrorBanner("Max file size exceeded " + max_duration + ", please try again");

                    return false;
                } else {
                    hideErrorBanner();
                }


                var types = ["video/mp4", "video/avi", "video/wmv", "video/mov", "video/flv", "video/quicktime"];
                if (types.indexOf(f.type) == -1) {
                    hideLoading();
                    showErrorBanner("Unsupported file format, please try again. Acceptable file formats include mp4, wmv, avi, mov, flv.");
                    return false;
                }


                var timer = setInterval(function () {
                    if (videoElement.readyState === 4) {
                        duration = videoElement.duration.toFixed(2);
                        clearInterval(timer);
                        hideLoading();
                        if (duration > max_duration) {
                            //alert("Maximum duration (" + max_duration + " sec.) exceeded");
                            showErrorBanner("Your video exceeds " + max_duration + " seconds, please try again");
                        } else {
                            hideErrorBanner();
                            cb();
                        }
                    }

                    if (i == 3) {
                        clearInterval(timer);
                        console.log("Cant determine video length.");
                        cb();
                    }
                    i++;
                }, 500);


            }

            function showErrorBanner(msg) {
                $("#error-banner-message").html("<b>Error:</b> " + msg);
                $("#error-banner").show();
            }


            function hideErrorBanner() {
                $("#error-banner").hide();
            }

            function saveFile(e) {
                debugger;
                hideErrorBanner();
                camera = false;
                if (e.files.length > 0) {
                    validateFile(e.files[0], function () {
                        upload(e.files[0], null, false);
                    });


                } else {
                    alert("Error: File not found!");
                }
            }

            function capture() {
                $("#captureVideo").show();
            }

            function checkFile() {

            }

            function infoBack() {
                debugger;
                $("#testimonial_video_info").hide();

                if (camera) {

                    $("#record-video").show();
                    $("#video-recording").hide();
                    $("#video-available").show();
                    $("#testimonial_video_upload").show();


                } else {
                    $("#upload-preview").show();
                }

            }

            function infoNext() {

            }

            function submitVideo() {
                debugger;
                var t = $('#checkbox_confirm').is(':checked');
                if (t) {
                    $("#testimonial_disclaimer").hide();
                    showInformation();


                    goUp();
                }
            }

            function showInformation() {
                debugger;
                var url = $("#video-url").val();
                $("#authorEmail").val(email);
                var isIncentive = $("#isIncentive").val();
                if (isIncentive == 'True') {
                    var email = $("#email").val();
                    var name = $("#name").val();
                }
                else {
                    var name = $("#firstName").val() + ' ' + $("#lastName").val();
                }


                $("#authorName").val(name);
                $("#testimonial_video_info").show();
                $("#confirmation").prop('checked', false);
                $("#checkbox_confirm").prop('checked', false);
                $("#video-upload-pre").attr("src", url);
                $("#video-pre").attr("src", url);
            }

            function confirmSubmit() {
                 
                var t = $('#checkbox_confirm').is(':checked');

                if (t) {
                    $("#button-confirm").removeClass("button-disabled");
                } else {
                    $("#button-confirm").addClass("button-disabled");
                }
            }

            function confirmInfo() {
                var firstName = "";
                var lastName = "";
                var isIncentive = $("#isIncentive").val();

                if (isIncentive == 'True') {
                    firstName = $("#name-voucher").val();
                    lastName = $("#email-voucher").val();
                }
                else {
                    firstName = $("#firstName").val();
                    lastName = $("#lastName").val();

                }

                var t = $('#confirmation').is(':checked');
                if (t && firstName != undefined && firstName != '' && lastName != undefined && lastName != '') {

                    $("#infoNextButton").removeClass("button-disabled");
                    $("#button-confirm").removeClass("button-disabled");
                } else {
                    $("#infoNextButton").addClass("button-disabled");
                    $("#button-confirm").addClass("button-disabled");
                }
            }



            function validateUpload() {
               debugger
                if (!$("#validateForm").valid()) {
                    return;
                }

                var t = $('#confirmation').is(':checked');

                var firstName = "";
                var lastName = "";
                var isIncentive = $("#isIncentive").val();

                if (isIncentive == 'True') {
                    firstName = $("#name-voucher").val();
                    lastName = $("#email-voucher").val();
                }
                else {
                    firstName = $("#firstName").val();
                    lastName = $("#lastName").val();

                }

                var t = $('#confirmation').is(':checked');
                if (t && firstName != undefined && firstName != '' && lastName != undefined && lastName != '') {

                }
                else {
                    return
                }


                var isIncentive = $("#isIncentive").val();
                if (isIncentive == 'True') {
                    var namev = $("#name-voucher").val();
                    var emailv = $("#email-voucher").val();

                    $("#authorEmail").val(emailv);
                    $("#authorName").val(namev);
                }
                else {

                    var firstName = $("#firstName").val();
                    var lastName = $("#lastName").val();
                    $("#authorName").val(firstName + ' ' + lastName);
                    $("#authorNameSpan").text($("#authorName").val());
                    $("authorNameA").attr("href", encodeURI("/testimonials/disclaimer?name=" + $("#authorName").val()));
                } 
                 

                showLoading();
                var formData = $("#validateForm").serialize();

                $.ajax({
                    cache: false,
                    processData: false,
                    type: 'POST',
                    url: validate_url,
                    data: formData,
                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                    success: function (data) { 
                        hideLoading();

                        if (data.success) {
                            hideErrorBanner();
                            $("#testimonial_video_info").hide();
                            $("#testimonial_video_validation").show();

                        } else {
                            showErrorBanner(data.message);
                        }

                    },
                    error: function (request, status, error) {
                        debugger;
                        hideLoading();
                        showErrorBanner(data.message);
                    }
                });
            }

            function uploadTrigger(e) {
                hideErrorBanner();
                $("#inputImage").trigger("click");
            }


            return {
                setup: setupPage,
                saveFile: saveFile,
                capture: capture,
                uploadVideo: uploadVideo,
                uploadTrigger: uploadTrigger,
                recordVideo: recordVideo,
                submitVideo: submitVideo,
                checkFile: checkFile,
                goBack: goBack,
                goBackDisclaimer: goBackDisclaimer,
                confirmInfo: confirmInfo,
                infoBack: infoBack,
                goBackUpload: goBackUpload,
                infoNext: infoNext,
                confirmSubmit: confirmSubmit,
                uploadNext: uploadNext,
                validate: validateUpload,
                saveVideoUrl: function (url) {
                    save_uploaded_video_url = url;
                },
                validateUrl: function (url) {
                    validate_url = url;
                }
            };

        }());
    }
});


$(function () {
    if ($('#video_page_testimonials').length) {

        $(document).ready(function () {

            var maxLength = 300;
            $(".show-read-more").each(function () {
                var myStr = $(this).text();
                if ($.trim(myStr).length > maxLength) {
                    var newStr = myStr.substring(0, maxLength);
                    var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
                    $(this).empty().html(newStr);
                    $(this).append('<a href="javascript:void(0);" class="read-more">..... Read More</a>');
                    $(this).append('<span class="more-text">' + removedStr + '</span>');
                }
            });
            $(".read-more").click(function () {
                $(this).siblings(".more-text").contents().unwrap();
                $(this).remove();
            });

        });



    }

});

$(function () {
    if ($('#my_site_page').length) {
        $(document).ready(function () {
            var maxLength = 300;
            $(".show-read-more").each(function () {
                var myStr = $(this).text();
                if ($.trim(myStr).length > maxLength) {
                    var newStr = myStr.substring(0, maxLength);
                    var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
                    $(this).empty().html(newStr);
                    $(this).append('<a href="javascript:void(0);" class="read-more">..... Read More</a>');
                    $(this).append('<span class="more-text">' + removedStr + '</span>');
                }
            });
            $(".read-more").click(function () {
                $(this).siblings(".more-text").contents().unwrap();
                $(this).remove();
            });




        });
    }
});

window.copyurl = function (value, id) {


    var $temp = $("<input>");
    var $url = value;
    $("body").append($temp);
    $temp.val($url).select();



    try {
        document.execCommand("copy");
        $temp.remove();
        $("#copy-" + id).hide();
        $("#copied-" + id).show();

        setTimeout(() => {
            $("#copy-" + id).show();
            $("#copied-" + id).hide();
        }, 1500);
    } catch (err) {
        console.log('Unable to copy text');
    }
    //t.innerHTML = '';


    //var $temp = $("<input>");
    //var $url = value;
    //$("body").append($temp);
    //$temp.val($url).select();
    //document.execCommand("copy");
    //$temp.remove();

}